import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { editOrder, getAllOrders } from "../../../redux/features/orders/ordersService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleXmark, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import TableSkeleton from "../../../components/Skeleton";
import NoResultsFound from "../../../components/NoResultsFound";
import { NumericFormat } from "react-number-format";
import { editQuickInvoice, getAllQuickInvoiceList } from "../../../redux/features/quickInvoice/quickInvoiceService";
import SearchBar from "../../../components/SearchBar";
import { showToast } from "../../../components/ToastMsg";
import Modal from "../../../components/Modal";

const QuickInvoices = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isInvoiceListLoading, invoiceList, pageCount } = useSelector((state) => state.quickInvoice.allInvoiceList);

    const [skip, setSkip] = useState(0);
    const limit = 10;
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        dispatch(getAllQuickInvoiceList({
            skip: skip,
            limit,
            invoice_no: searchQuery,
            status: true,
        }));
    }, [dispatch, searchQuery, skip]);

    const openNewInvoice = () => navigate('/admin/quick-invoices/create-quick-invoice');

    const viewDocument = (document) => {
        window.open(document.invoice_document, "_blank");
    }

    const handlePageChange = (pageNumber) => {
        setSkip(pageNumber - 1);
    };

    const editDocument = (document) => navigate(`/admin/quick-invoices/${document.id}`);

    //  Delete
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);

    const closDeactivationModal = () => setDeactivationModalOpen(false);

    const handleRejectYes = async () => {
        setDeactivationModalOpen(false);
        const date = new Date().toISOString().split("T")[0];
        try {
            const response = await dispatch(editQuickInvoice({ invoice_id: selectedInvoice, status: 'false', invoice_date: date })).unwrap();
            setSelectedInvoice(null);
            showToast('success', response.message);
            dispatch(getAllQuickInvoiceList({
                skip: skip,
                limit,
                status: true
            }));
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    return (
        <div className={`card-section`}>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Quick Invoices <FontAwesomeIcon icon={faPlusCircle} onClick={openNewInvoice} style={{ cursor: 'pointer' }} /></h1>
                    <SearchBar onSearch={(query) => setSearchQuery(query)} />
                </div>
                <div className={`search-card-body`}>
                    {isInvoiceListLoading ?
                        <TableSkeleton columns={["Invoice No", "Invoice Date", "Bill to Name", "Country", "Currency", "Staff", "Invoice"]} rowCount={10} height={20} />
                        : invoiceList.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={`theadColumnOne`}>Invoice No</th>
                                            <th>Invoice Date</th>
                                            <th>Bill to Name</th>
                                            <th>Country</th>
                                            <th>Currency</th>
                                            <th>Staff</th>
                                            <th>Invoice</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {invoiceList?.map((invoice) => (
                                            <tr key={invoice.id}>
                                                <td className={`tdataColumnOne`}>
                                                    {invoice?.invoice_no}
                                                </td>
                                                <td>{invoice?.invoice_date}</td>
                                                <td>{invoice?.bill_to_name}</td>
                                                <td>{invoice?.country}</td>
                                                <td>{invoice?.currency}</td>
                                                <td>{invoice?.staff?.full_name}</td>
                                                <td className={`actionsBtn ${styles.actionCol}`}>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        viewDocument(invoice)
                                                    }}>View</button>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        editDocument(invoice)
                                                    }}>Edit</button>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        setSelectedInvoice(invoice.id);
                                                        setDeactivationModalOpen(true);
                                                    }}>Delete</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                <div className={`search-card-footer`}>
                    {pageCount > 0 && (
                        <div className={styles.paginationContainer}>
                            <Pagination
                                currentPage={skip + 1}
                                totalPages={pageCount}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    )}
                </div>
            </div>
            {isDeactivationModalOpen && (
                <Modal
                    title='Delete Invoice'
                    onClose={closDeactivationModal}
                    onYes={handleRejectYes}
                    isInput={false}
                    iconName={faCircleXmark}
                    bodyText={`Are you sure you want to delete the Invoice?`}
                    colorType={`var(--danger)`}
                />
            )}
        </div>
    );
};

export default QuickInvoices;
